import React, { useEffect } from 'react';

const PrivacyPolicyPage = () => {
  useEffect(() => {
    document.title = 'Privacy Policy | SIDEO QR';
  }, []);

  return (
    <main className="min-h-screen bg-slate-50 py-10 px-4 sm:px-6 lg:px-8">
      <article className="max-w-3xl mx-auto bg-white border border-slate-200 rounded-2xl shadow-sm p-6 sm:p-8 lg:p-10">
        <header className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900" style={{ fontFamily: 'Barlow' }}>
            Privacy Policy
          </h1>
          <p className="text-sm text-slate-500 mt-2">Last Updated: March 24, 2026</p>
        </header>

        <div className="space-y-7 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">1. Introduction</h2>
            <p>
              This Privacy Policy explains how SIDEO QR collects, uses, protects, and handles your information when
              you purchase, activate, and use our physical QR sticker service for vehicles.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">2. Information Collected</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Phone number linked during activation.</li>
              <li>Basic usage data such as activation status, scan-related event logs, and service interactions.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">3. How We Use Information</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>To enable call and message functionality when your QR code is scanned.</li>
              <li>To operate, maintain, troubleshoot, and improve service performance.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">4. Data Protection</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Your phone number is not publicly visible to people scanning the QR code.</li>
              <li>We apply reasonable security practices and procedures to protect data.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">5. Data Sharing</h2>
            <p>
              We do not sell your personal data. We may share limited data only when necessary to operate the service,
              comply with legal obligations, or protect rights and safety.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">6. Data Retention</h2>
            <p>
              We retain your personal data while your service is active and for reasonable periods as required for
              compliance, dispute resolution, and legitimate business purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">7. User Rights</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Request updates to your linked phone number and account details.</li>
              <li>Request deactivation of your QR-linked service.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">8. Third-Party Disclaimer</h2>
            <p>
              Some service components may rely on third-party infrastructure (for example, telecom or hosting
              providers). We are not responsible for independent privacy practices of third-party websites or services
              outside our control.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">9. Changes to this Policy</h2>
            <p>
              We may revise this Privacy Policy from time to time. Updates are effective when posted on this page,
              unless stated otherwise.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">10. Contact</h2>
            <p>
              For privacy-related queries or requests, contact us at <a href="mailto:support@sideo.in" className="text-black hover:underline">support@sideo.in</a>.
            </p>
          </section>
        </div>
      </article>
    </main>
  );
};

export default PrivacyPolicyPage;
